import React, { useEffect } from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import Header from './Header';
import FormModern from './FormModern';

const Success = () => {
  useEffect(() => {
    // Load Calendly widget script
    const script = document.createElement('script');
    script.src = 'https://assets.calendly.com/assets/external/widget.js';
    script.async = true;
    document.body.appendChild(script);
    
    return () => {
      // Clean up the script when the component unmounts
      document.body.removeChild(script);
    };
  }, []);

  return (
    <div>
      <Header />
      <SuccessContainer>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <SuccessCard>
            <h1>Thank you for buying your 90 minutes<br/>AI coaching session with Riz Pabani.</h1>
            
            <BookingSection id="calendar-section">
              <InstructionText>Book your session using the <a href="#calendar-section">calendar</a> and <br/>complete the pre-session <a href="#form-section">questionnaire</a> below</InstructionText>
              {/* Calendly inline widget begin */}
              <div 
                className="calendly-inline-widget" 
                data-url="https://calendly.com/dreamsaicanbuy-info/book" 
                style={{ minWidth: "320px", height: "930px" }}
              ></div>
              {/* Calendly inline widget end */}
            </BookingSection>
            
            <FormSection id="form-section">
              <FormWrapper>
                <FormModern embedMode={true} />
              </FormWrapper>
            </FormSection>
          </SuccessCard>
        </motion.div>
      </SuccessContainer>
    </div>
  );
};

const SuccessContainer = styled.section`
  padding: 5rem 0;
  background: linear-gradient(90deg, #f8f9fa 0%, #f6f7f8 100%);
  min-height: 100vh;
`;

const SuccessCard = styled.div`
  background-color: var(--white);
  border-radius: 8px;
  padding: 3rem;
  box-shadow: var(--shadow);
  max-width: 900px;
  margin: 0 auto;
  
  h1 {
    color: var(--primary-color);
    margin-bottom: 2rem;
    text-align: center;
    font-size: 1.8rem;
  }
  
  h2 {
    color: var(--primary-color);
    margin: 2rem 0 1rem;
    font-size: 1.5rem;
    
    a {
      color: var(--primary-color);
      text-decoration: underline;
      transition: all 0.3s ease;
      font-weight: bold;
      
      &:hover {
        color: #003b8a;
      }
    }
  }
  
  @media (max-width: 768px) {
    padding: 2rem;
    
    h1 {
      font-size: 1.5rem;
    }
    
    h2 {
      font-size: 1.3rem;
    }
  }
`;

const BookingSection = styled.div`
  margin: 3rem 0;
`;

const FormSection = styled.div`
  margin: 3rem 0;
`;

const FormWrapper = styled.div`
  margin-top: 2rem;
`;

const InstructionText = styled.p`
  color: var(--primary-color);
  margin: 2rem 0 1rem;
  font-size: 1.3rem;
  text-align: center;
  font-weight: normal;
  
  a {
    color: var(--primary-color);
    text-decoration: underline;
    transition: all 0.3s ease;
    font-weight: bold;
    
    &:hover {
      color: #003b8a;
    }
  }
`;

export default Success; 